import { useMutation } from '@tanstack/react-query';
import { getSavingsCapacitySuggestion } from '../utils/savingsCapacity';

export function useSavingsCapacitySuggestion() {
  return useMutation({
    mutationFn: async (payload: unknown) => getSavingsCapacitySuggestion(payload),
  });
}
